import { useSelector } from "react-redux";

export function useStapelDocumentCount() {
  const stapels =
    useSelector(
      (state: any) => state.user.userhavetostapelsigndocs
    ) || [];

  const stapelArray = Array.isArray(stapels)
    ? stapels
    : Object.values(stapels);

  const getStapelCountForDocument = (resourceId: string) => {
    let count = 0;

    stapelArray.forEach((stapel: any) => {
      if (
        stapel.documentsSignModes?.some(
          (d: any) => d.resourceId === resourceId
        )
      ) {
        count++;
      }
    });

    return count;
  };

  return { getStapelCountForDocument };
}
